import { useEffect, useState } from "react";
import classNames from "classnames";
import { TextIcon } from "components/atoms/TextIcon";
import { Typography } from "components/atoms/Typography";
import { useScreenSize } from "hooks";
import { TAB_WIDTH, MOBILE_WIDTH } from "utils/constants";
import { ButtonsByContentObjectTypes } from "../ButtonsByContentObjectTypes";
import "./index.scss";

interface IProps {
  index: number;
  textIconLabel: string;
  iconType?: undefined | "yellow-timer" | "select" | "empty-circle" | "lock" | "arrow-right";
  middleLabel?: string | null;
  isBtn?: boolean;
  theme: "light" | "dark";
  status: string;
  contentObjectType: any;
  isLocked: boolean;
  handlePrimaryBtnClick?: () => any;
  handleSecondaryBtnClick?: () => any;
  isRecommended?: boolean; // Indicates if this is the recommended next drill
}

export const DrillSmartHomeWorkRow = ({
  textIconLabel,
  iconType,
  middleLabel,
  theme,
  status,
  contentObjectType,
  isLocked,
  handlePrimaryBtnClick,
  handleSecondaryBtnClick,
  isRecommended,
}: IProps) => {
  const [responsiveMiddleLabel, setResponsiveMiddleLabel] = useState("");

  useEffect(() => {
    if (middleLabel && middleLabel.length > 5) {
      setResponsiveMiddleLabel(middleLabel.slice(0, 5) + "...");
    }
  }, []);

  const screen = useScreenSize();

  return (
    <div
      className={classNames(
        "drill-smart-home-work-row-wrapper",
        screen.width > MOBILE_WIDTH && screen.width <= TAB_WIDTH
          ? "tab-style"
          : ""
      )}
    >
      {screen.width <= 1550 ? (
        <div className="home-tab-size-wrapper">
          <div
            className={classNames({
              "icon-text-section": true,
              "text-gray": iconType === "lock",
            })}
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <TextIcon
              label={textIconLabel}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </div>
      ) : (
        <>
          <div
            className={classNames({
              "icon-text-section": true,
              "text-gray": iconType === "lock",
            })}
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <TextIcon
              label={textIconLabel}
              icon={true}
              isReverse={true}
              iconType={iconType}
              isTabStyle={true}
              theme={theme}
            />
          </div>

          <div
            className={classNames({
              "middle-section": true,
              "text-gray": iconType === "lock",
            })}
          >
            {middleLabel && (
              <Typography
                variant="h8Med"
                label={middleLabel}
                styles="custom-middle-home-style"
              />
            )}
          </div>
        </>
      )}

      {screen.width > MOBILE_WIDTH ? (
        <div
          className={classNames(
            "btn-section",
            screen.width <= 810 || (screen.width > 1024 && screen.width < 1226)
              ? "course-index-tab-btn-handle"
              : ""
          )}
        >
          <ButtonsByContentObjectTypes
            status={status}
            isLocked={isLocked}
            contentObjectType={contentObjectType}
            handlePrimaryBtnClick={handlePrimaryBtnClick}
            handleSecondaryBtnClick={handleSecondaryBtnClick}
          />
        </div>
      ) : null}
    </div>
  );
};
